<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm5 md4>
        <v-card class="pa-1" style="border-radius:20px;">
          <div class="ta-c mb-3 mt-5">
            <!-- <img
              src="../../assets/images/logo_plant3.png"
              alt=""
              class="logo-size"
            /> -->
            <h1>72 ล้านต้น</h1>
          </div>
          <v-card-text>
            <v-form>
              <v-layout row wrap justify-center>
                <v-flex xs12 md10>
                  <v-text-field
                    label="ชื่อผู้ใช้"
                    prepend-inner-icon="person"
                    solo
                    hide-details
                    color="blue"
                    v-model="username"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap justify-center>
                <v-flex xs12 md10>
                  <v-text-field
                    label="รหัสผ่าน"
                    prepend-inner-icon="lock"
                    solo
                    hide-details
                    color="blue"
                    v-model="password"
                    required
                    type="password"
                    @keyup.enter="adminLogin()"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions style="justify-content:center;" class="mb-4">
            <v-btn color="primary" round @click="adminLogin()"
              >เข้าสู่ระบบ</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { Encode } from "@/services";
export default {
  data() {
    return {
      username: "",
      password: "",
      listInformationAdmin: [],
    };
  },
  props: {
    source: String,
  },
  methods: {
    gotoLink(link) {
      this.$router.push(link);
    },
    adminLogin() {
      if (this.username === "" || this.password === "") {
        this.$swal("กรุณากรอกชื่อผู้ใช้และรหัสผ่านให้ครบถ้วน", "", "error");
        return;
      }
      this.axios
        .post(process.env.VUE_APP_IPFLASK + "/adminLogin", {
          username: this.username,
          password: this.password,
        })
        .then((response) => {
          // console.log(response.data);
          if (response.data !== "Not found User") {
            //console.log(response.data);
            this.listInformationAdmin = response.data;
            var name_encode = Encode.encode({
              name: this.listInformationAdmin[0].name,
            });
            var permission = Encode.encode({
              permission: this.listInformationAdmin[0].permission,
            });
            // console.log(name_encode);
            this.$cookies.set(
              "admin_name",
              name_encode,
              "1d",
              "/",
              process.env.VUE_APP_WEB
            );
            this.$cookies.set(
              "permission",
              permission,
              "1d",
              "/",
              process.env.VUE_APP_WEB
            );
            if (this.listInformationAdmin[0].permission === "2") {
              this.$router.push("/report_studentloan");
            } else {
              this.$router.push("/report_nursery");
            }
          } else {
            this.$swal(
              "ไม่พบผู้ใช้ในระบบ",
              "กรุณาตรวจสอบชื่อผู้ใช้และรหัสผ่าน",
              "error"
            );
          }
        });
    },
  },
};
</script>

<style scoped>
@media only screen and (min-width: 321px) and (max-width: 600px) {
  .logo-size {
    width: 90px;
    height: 90px;
  }
}

@media only screen and (min-width: 601px) and (max-width: 960px) {
  .logo-size {
    width: 90px;
    height: 90px;
  }
}

@media only screen and (min-width: 961px) {
  .logo-size {
    width: 100px;
    height: 100px;
  }
}
</style>
